import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, SkeletonCard, SkeletonContent, SkeletonHeader, SkeletonCounter } from "./styles";

interface ComentariosSkeletonProps {
    count?: number;
    showCounter?: boolean;
}

export default function ComentariosSkeleton({ count = 3, showCounter = false }: ComentariosSkeletonProps) {
    return (
        <Container>
            {showCounter && (
                <SkeletonCounter>
                    <Skeleton width={20} height={20} circle />
                    <Skeleton width={180} height={16} />
                </SkeletonCounter>
            )}
            {Array.from({ length: count }).map((_, index) => (
                <SkeletonCard key={index}>
                    <Skeleton circle width={40} height={40} />
                    <SkeletonContent>
                        <SkeletonHeader>
                            <Skeleton width={150} height={13} />
                            <Skeleton width={80} height={20} borderRadius={12} />
                            <Skeleton width={100} height={11} />
                        </SkeletonHeader>
                        <Skeleton width="100%" height={60} style={{ marginTop: '8px' }} />
                    </SkeletonContent>
                </SkeletonCard>
            ))}
        </Container>
    );
}




